import Image, { type StaticImageData } from "next/image";
import Graylocation from "@public/Assets/Icons/GrayLocation.svg";
import Cyanlocation from "@public/Assets/Icons/CyanLocation.svg";
import Yellowlocation from "@public/Assets/Icons/YellowLocation.svg";
import Redlocation from "@public/Assets/Icons/RedLocation.svg";

interface SyncIconProps {
  type:
    | "GrayLocation"
    | "CyanLocation"
    | "YellowLocation"
    | "RedLocation"
    | "Circle"
    | "NumberLocation";
  number?: React.ReactNode;
  image?: StaticImageData;
  imageClassName?: string;
  locationCLassName?: string;
  numberClassName?: string;
}

export const MapPinPointAtom = (props: SyncIconProps) => {
  return (
    <section>
      {props.type === "Circle" ? (
        <div className="inline-flex items-center justify-center p-[7px]">
          <div className="relative h-[18px] w-[18px] rounded-[20px] border-2 border-white bg-yellow-300 shadow" />
        </div>
      ) : (
        <div>
          <div className="relative flex h-[54px] w-[48px] items-center justify-center">
            <div className="flex h-[32px] w-[32px] items-center justify-center">
              {props.type === "NumberLocation" ? (
                <div
                  className={`body1-bold relative bottom-[2px] z-[2] flex h-[27.8px] items-center justify-center ${
                    props.numberClassName ?? ""
                  }`}
                >
                  {props.number}
                </div>
              ) : (
                props.image && (
                  <Image
                    src={props.image}
                    className={`relative z-[2] h-[27.8px] w-[24.32px] ${
                      props.imageClassName ?? ""
                    }`}
                    alt={props.type}
                    width={60}
                    height={60}
                  />
                )
              )}
            </div>

            <Image
              src={
                props.type === "NumberLocation" || props.type === "CyanLocation"
                  ? (Cyanlocation as StaticImageData)
                  : props.type === "YellowLocation"
                    ? (Yellowlocation as StaticImageData)
                    : props.type === "RedLocation"
                      ? (Redlocation as StaticImageData)
                      : props.type === "GrayLocation"
                        ? (Graylocation as StaticImageData)
                        : ""
              }
              className={`absolute inset-0 z-[1] h-[54px] w-[48px] ${props.locationCLassName}`}
              alt={props.type}
              width={60}
              height={60}
            />
          </div>
        </div>
      )}
    </section>
  );
};
